class EntityEnum {
    static user = "Users";
    static invite = "Invites";
}

export default EntityEnum;
